export const SCHEDULE_IN_ADVANCE_DEFAULT = 12;

export enum VisitorFieldEnum {
  Required = 'required',
  Optional = 'optional',
  Hide = 'hide',
}

export enum ScheduleTypeEnum {
  SpecificDate = 'specific_date',
  CustomDates = 'custom_dates',
  DateRange = 'date_range',
  Repeat = 'repeat',
}

export enum IntervalTypeEnum {
  EveryDay = 'every_day',
  EveryWeekday = 'every_weekday',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export enum MonthIntervalTypeEnum {
  OnDate = 'on_date',
  FirstOfDay = 'first_of_day',
  SecondOfDay = 'second_of_day',
  ThirdOfDay = 'third_of_day',
  FourthOfDay = 'fourth_of_day',
  LastOfDay = 'last_of_day',
}

export enum VisitorMenuEnum {
  General = 'General',
  Scheduling = 'Scheduling Options',
}

export enum ScheduleInAdvanceEnum {
  One = '1 Month',
  Two = '2 Months',
  Three = '3 Months',
  Four = '4 Months',
  Five = '5 Months',
  Six = '6 Months',
  Seven = '7 Months',
  Eight = '8 Months',
  Nine = '9 Months',
  Ten = '10 Months',
  Eleven = '11 Months',
  Twelve = '12 Months',
}

export const repeatDropdownItems = [
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.everyday',
    value: IntervalTypeEnum.EveryDay,
  },
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.everyWeekday',
    value: IntervalTypeEnum.EveryWeekday,
  },
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.weekly',
    value: IntervalTypeEnum.Weekly,
  },
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.monthly',
    value: IntervalTypeEnum.Monthly,
  },
];

export const scheduleInAdvanceOptions = [
  {
    label: ScheduleInAdvanceEnum.One,
    value: 1,
  },
  {
    label: ScheduleInAdvanceEnum.Two,
    value: 2,
  },
  {
    label: ScheduleInAdvanceEnum.Three,
    value: 3,
  },
  {
    label: ScheduleInAdvanceEnum.Four,
    value: 4,
  },
  {
    label: ScheduleInAdvanceEnum.Five,
    value: 5,
  },
  {
    label: ScheduleInAdvanceEnum.Six,
    value: 6,
  },
  {
    label: ScheduleInAdvanceEnum.Seven,
    value: 7,
  },
  {
    label: ScheduleInAdvanceEnum.Eight,
    value: 8,
  },
  {
    label: ScheduleInAdvanceEnum.Nine,
    value: 9,
  },
  {
    label: ScheduleInAdvanceEnum.Ten,
    value: 10,
  },
  {
    label: ScheduleInAdvanceEnum.Eleven,
    value: 11,
  },
  {
    label: ScheduleInAdvanceEnum.Twelve,
    value: 12,
  },
];

export const getMaxDateRangeOptions = (max: number) =>
  scheduleInAdvanceOptions.slice(0, Math.max(max, 1));

export const START_HOUR = 9;
export const END_HOUR = 17;
